export default {
    root: ({ context, props }) => ({
        class: [
            // Position and Shadows
            'absolute',
            'shadow-md',
            'p-fadein',
            'rounded-md', // blr07

            // Spacing
            {
                //'py-0 px-1': context?.right || context?.left || (!context?.right && !context?.left && !context?.top && !context?.bottom),
                //'py-1 px-0': context?.top || context?.bottom
                'py-0 px-0 translate-x-1': context?.right || (!context?.right && !context?.left && !context?.top && !context?.bottom), // blr07
                'py-0 px-0 -translate-x-1': context?.left, // blr07
                'py-0 px-0 translate-y-1': context?.bottom, // blr07
                '-mt-1 px-0': context?.top, // blr07
            }
        ]
    }),
    arrow: ({ context, props }) => ({
        class: [
            // Position
            'absolute',
            'top-10', // blr07

            // Size
            'w-0',
            'h-0',

            // Shape
            'border-transparent',
            'border-solid',
            {
                'border-y-[0.25rem] border-r-[0.25rem] border-l-0 border-r-surface-600': context?.right || (!context?.right && !context?.left && !context?.top && !context?.bottom),
                'border-y-[0.25rem] border-l-[0.25rem] border-r-0 border-l-surface-600': context?.left,
                'border-x-[0.25rem] border-t-[0.25rem] border-b-0 border-t-surface-600': context?.top,
                'border-x-[0.25rem] border-b-[0.25rem] border-t-0 border-b-surface-600': context?.bottom
            },

            // Spacing
            {
                //'-mt-1 ': context?.right || (!context?.right && !context?.left && !context?.top && !context?.bottom),
                //'-mt-1': context?.left,
                '-mt-1 ml-[-5px]': context?.right || (!context?.right && !context?.left && !context?.top && !context?.bottom), // blr07
                '-mt-1 mr-[-5px]': context?.left, // blr07
                '-ml-1 mt-[-5px]': context?.bottom, // blr07
                '-ml-1': context?.top, // blr07
            }
        ]
    }),
    text: {
        class: ['p-3', 'bg-surface-600 dark:bg-surface-700', 'text-white', 'leading-none', 'rounded-md', 'whitespace-pre-line', 'break-words']
    }
};
